import agents from '../../../../../api/agents/hooks'

const ActiveButton = ({ user, filteredUsers, disabled }) => {
    const { mutate: updateAgent } = agents.UpdateAgent.useMutation()

    const handleActiveUser = (user) => {
        const activeUserLocal = JSON.parse(JSON.stringify(user))
        activeUserLocal.active = !activeUserLocal.active

        // exclude fields the backend doesn't expect on update
        const {
            id: agentId,
            agency: _agency,
            agencyOffice: _agencyOffice,
            defaultCounty: _defaultCounty,
            defaultCountry: _defaultCountry,
            defaultCity: _defaultCity,
            agentPermissions: _agentPermissions,
            ...data
        } = JSON.parse(JSON.stringify(activeUserLocal))

        updateAgent(
            { agentId, data },
            {
                onSuccess: () => {
                    const index = filteredUsers.findIndex((item) => item.id === user?.id)
                    filteredUsers[index] = activeUserLocal
                },
            }
        )
    }
    return (
        <button
            disabled={disabled}
            type="button"
            className="btn btn-light btn-icon rounded-circle btn-md favourite-btn"
            onClick={() => handleActiveUser(user)}
        >
            <i className={`mdi ${user?.active ? 'mdi-account-check text-success' : 'mdi-account-cancel text-danger'} fs-20`}></i>
        </button>
    )
}

export default ActiveButton
